import { type ReactNode, type FC } from 'react';
import SearchBlockContext, { type SearchBlockContextProps, type SearchBlockProps } from './SearchBlockContext';

interface SearchBlockProviderProps extends SearchBlockProps {
    children: ReactNode;
}

const SearchBlockProvider: FC<SearchBlockProviderProps> = ({
    children,
    ...restProps
}) => {
    const providerValue: SearchBlockContextProps = { ...restProps };

    return (
        <SearchBlockContext.Provider value={providerValue}>
            {children}
        </SearchBlockContext.Provider>
    );
};

export default SearchBlockProvider;
